/* eslint-disable react/button-has-type */
// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdAdd } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import User from '../User';
import Card from '../Card';
import * as selectors from '../../reducers';
import * as parentActions from '../../actions/parents';
import * as studentActions from '../../actions/students';
import * as closeableActions from '../../actions/closeable';
import CardHeader from '../CardHeader';
import CardContent from '../CardContent';
import ParentDataPanel from './ParentDataPanel';
import CardHeaderRightGroup from '../CardHeaderRightGroup';
import CardHeaderTitleContainer from '../CardHeaderTitleContainer';

import OmnisearchLoadingResults from '../OmnisearchLoadingResults';
import Collapsable from '../Accordion/Collapsable';
import Panel from '../Accordion/Panel';
import StudentsPanel from './StudentsPanel';
import StudentSearchPopover from '../StudentSearchPopover';

import styles from './parentCard.css';
import type { PARENT_TYPE } from '../../types/parents';
import { ReduxClickPopover } from '../Closeable';
import { getDefaultValue } from '../UserContactsForm/utils';
import { getUserImage } from '../../utils';

type ParentCardDummyPropTypes = {
  parent: PARENT_TYPE,
  updateParent: Function,
  addStudentParentStarted: Function,
};

const ParentCardDummy = ({
  parent,
  updateParent,
  addStudentParentStarted,
  ...props
}: ParentCardDummyPropTypes) => (
  <Fragment>
    <Card className={styles.parentCard} isRound {...props}>
      <CardHeader>
        <CardHeaderTitleContainer>
          {
            typeof parent !== 'undefined'
              ? (
                <User
                  firstName={parent.user.first_name}
                  lastName={parent.user.last_name}
                  userRole="parent"
                  pictureURL={getUserImage(parent.user.profile_picture)}
                  useAsTitle
                />
              ) : <OmnisearchLoadingResults />
              }
        </CardHeaderTitleContainer>
        <CardHeaderRightGroup />
      </CardHeader>
      <CardContent clearPaddings>
        <Collapsable accordion>
          {
          parent && (
          <Panel
            title={i18n.t('titles.personalInfo')}
            key="personalInfo"
          >
            <ParentDataPanel parent={parent} updateParent={updateParent} />
          </Panel>)
        }
          <Panel
            ActionComponent={
          () => (
            <ReduxClickPopover
              isInline
              id="addContactCard"
              Content={StudentSearchPopover}
              vertical="middle"
              horizontal="after"
              tipPosition="middle"
              isRound="true"
              onStudentSelected={(element) => {
                addStudentParentStarted(parseInt(element.id, 10), parent.id);
              }}
            >
              <button type="actionButton" className={styles.addButton}>
                <MdAdd size={30} />
              </button>
            </ReduxClickPopover>
          )
        }
            title={i18n.t('titles.contacts')}
            key="contacts"
          >
            {parent && <StudentsPanel parentId={parent.id} />}
          </Panel>
        </Collapsable>
      </CardContent>
    </Card>
  </Fragment>
);

const ParentCard = connect(
  (state, props) => {
    const { id } = props;
    const parent = selectors.getParent(state, parseInt(id, 10));
    return {
      parent,
    };
  },
  dispatch => ({
    updateParent(parent) {
      dispatch(parentActions.updateParentStart({ ...parent }));
    },
    open: (id: string) => dispatch(closeableActions.open(id)),
    addStudentParentStarted: (
      idStudent: number,
      idParent: number,
    ) => dispatch(studentActions.addStudentParentStarted(idStudent, idParent)),
  }),
)(ParentCardDummy);


export default ParentCard;



// WEBPACK FOOTER //
// ./src/scripts/components/ParentCard/index.jsx